import { z } from 'zod';

// Esquemas de administración de accesos (RF-01.20 a RF-01.27). La interfaz llega con A-14.

export const invitationCreateSchema = z.object({
  maxUses: z.number().int().positive().nullable(),
  expiresAt: z.iso.datetime().nullable(),
  note: z.string().max(300),
});

export const invitationCreatedSchema = z.object({
  id: z.uuid(),
  /** Se muestra una sola vez: después solo queda el prefijo. */
  code: z.string(),
});

export const invitationSchema = z.object({
  id: z.uuid(),
  codePrefix: z.string(),
  maxUses: z.number().int().nullable(),
  uses: z.number().int(),
  expiresAt: z.iso.datetime().nullable(),
  revokedAt: z.iso.datetime().nullable(),
  note: z.string(),
  createdAt: z.iso.datetime(),
});

export const membershipSchema = z.object({
  plan: z.enum(['unassigned', 'monthly', 'annual', 'lifetime']),
  renewalOn: z.iso.date().nullable(),
  origin: z.string(),
  notes: z.string(),
  reviewedAt: z.iso.datetime().nullable(),
  version: z.number().int(),
});

export const membershipUpdateSchema = z.object({
  plan: z.string().max(20),
  renewalOn: z.string().max(10).nullable(),
  origin: z.string().max(120),
  notes: z.string().max(2000),
  version: z.number().int().min(0),
});

export const userAccessSchema = z.object({
  roles: z.array(z.string()),
  permissions: z.array(z.string()),
  blocked: z.boolean(),
  blockReason: z.string().nullable(),
  overrides: z.array(
    z.object({ permission: z.string(), effect: z.enum(['grant', 'deny']), reason: z.string() }),
  ),
  membership: membershipSchema,
});

export const rolesUpdateSchema = z.object({ roles: z.array(z.string().max(40)).max(10) });
export const overrideSetSchema = z.object({
  effect: z.enum(['grant', 'deny']),
  reason: z.string().max(500),
});
export const blockSchema = z.object({ reason: z.string().max(500) });
